<template>
    <div class="d-flex justify-content-between align-items-center mt-3">
        <div>
            <select
                class="form-select form-select-sm d-inline-block"
                style="width: auto"
                :value="perPage"
                @change="$emit('change-per-page', Number($event.target.value))"
            >
                <option :value="25">25 รายการ</option>
                <option :value="50">50 รายการ</option>
                <option :value="100">100 รายการ</option>
                <option :value="200">200 รายการ</option>
            </select>
        </div>
        <nav>
            <ul class="pagination pagination-sm mb-0">
                <li class="page-item" :class="{ disabled: pagination.current_page === 1 }">
                    <a class="page-link" href="#" @click.prevent="$emit('change-page', 1)"
                        >หน้าแรก</a
                    >
                </li>
                <li class="page-item" :class="{ disabled: pagination.current_page === 1 }">
                    <a
                        class="page-link"
                        href="#"
                        @click.prevent="$emit('change-page', pagination.current_page - 1)"
                    >
                        <i class="fas fa-chevron-left"></i>
                    </a>
                </li>

                <template v-for="(page, index) in visiblePages">
                    <li
                        v-if="page === '...'"
                        :key="'ellipsis-' + index"
                        class="page-item disabled"
                    >
                        <span class="page-link">...</span>
                    </li>
                    <li
                        v-else
                        :key="'page-' + page"
                        class="page-item"
                        :class="{ active: page == pagination.current_page }"
                    >
                        <a class="page-link" href="#" @click.prevent="$emit('change-page', page)">
                            {{ page }}
                        </a>
                    </li>
                </template>

                <li
                    class="page-item"
                    :class="{ disabled: pagination.current_page === pagination.total_pages }"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click.prevent="$emit('change-page', pagination.current_page + 1)"
                    >
                        <i class="fas fa-chevron-right"></i>
                    </a>
                </li>
                <li
                    class="page-item"
                    :class="{ disabled: pagination.current_page === pagination.total_pages }"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click.prevent="$emit('change-page', pagination.total_pages)"
                        >หน้าสุดท้าย</a
                    >
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'StockCountPagination',

    props: {
        pagination: {
            type: Object,
            required: true,
        },
        perPage: {
            type: Number,
            default: 50,
        },
    },

    computed: {
        visiblePages() {
            const current = Number(this.pagination.current_page);
            const total = Number(this.pagination.total_pages);
            const delta = 2;

            let pages = [];
            const start = Math.max(1, current - delta);
            const end = Math.min(total, current + delta);

            if (start > 1) {
                pages.push(1);
                if (start > 2) {
                    pages.push('...');
                }
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            if (end < total) {
                if (end < total - 1) {
                    pages.push('...');
                }
                pages.push(total);
            }

            return pages;
        },
    },
};
</script>
